import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';
import Lottie from 'lottie-react';
import TipsLottieAnimation from '../../../animations/tips_lottie_anim.json';
import './WelcomeScreenAnimation.css';

type WelcomeScreenProps = {
    className?: string;
};

const WelcomeScreenAnimation: React.FC<WelcomeScreenProps> = ({
    className = '',
}) => {
    return (
        <div className={`w-max welcome-screen-animation ${className}`}>
            <Lottie animationData={TipsLottieAnimation} loop={true} />
        </div>
    );
};

export default WelcomeScreenAnimation;
